var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"myCheck"},[_c('div',{class:_vm.checked ? ['checkBox', 'checked'] : 'checkBox',on:{"click":_vm.handleClick}}),_c('p',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('productList.all')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }